<template>
  <pt-promotion-review class="pt-promotion-review__withData" @reviewPass="reviewPass" ref="romotionReview"></pt-promotion-review>
</template>

<script>
import PtPromotionReview from './index'
export default {
  name: 'pt-promotion-review__withData',
  components: {
    'pt-promotion-review': PtPromotionReview
  },
  methods: {
    reviewPass (val) {
      let status
      if (val.promotionData && (val.promotionData.promotionType === 'CASH_BACK' || val.promotionData.promotionType === 'CPS_BIND')) {
        status = val.status === 'WAITING_AUDIT' ? 'WAITING_FINANCIAL_AUDIT' : (val.status === 'WAITING_FINANCIAL_AUDIT' ? 'ACTIVATED' : null)
      } else {
        status = 'ACTIVATED'
      }
      // status = val.status === 'WAITING_AUDIT' ? 'WAITING_FINANCIAL_AUDIT' : (val.status === 'WAITING_FINANCIAL_AUDIT' ? 'ACTIVATED' : null)
      let data = {
        id: val.id,
        status: status
      }
      this.$store.dispatch('promotionStatus', data).then(res => {
        this.$message.success('审核促销活动成功')
        this.$refs.romotionReview.promotionList()
      }).catch(err => {
        this.$message.error(err || '审核促销活动成功')
      })
    }
  }
}
</script>
